import React from 'react';

import { useLanguage } from '../LanguageContext';

const formatResponse = (
  value,
  yesLabel = 'Attending',
  noLabel = 'Not Attending',
) => {
  if (value === true) return yesLabel;
  if (value === false) return noLabel;
  return '—';
};

const getGuestName = (guestId, allGuests, t) => {
  const guest = Array.isArray(allGuests)
    ? allGuests.find((g) => String(g.id) === String(guestId))
    : null;
  return guest?.name || `${t('rsvp_form.guest')} ${guestId}`;
};

const getBanquetChoiceLabel = (choice, t) => {
  if (!choice) return '—';
  const lower = choice.toLowerCase();
  if (lower === 'fish') return t('rsvp_form.meat_fish');
  if (lower === 'beef') return t('rsvp_form.meat_beef');
  if (lower === 'vegetarian') return t('rsvp_form.meat_vegetarian');
  return choice;
};

const getDietaryLabel = (diet, t) => {
  if (!diet) return '—';
  if (diet === 'Halal') return t('rsvp_form.diet_halal');
  if (diet === 'Vegetarian') return t('rsvp_form.diet_vegetarian');
  if (diet.startsWith('Others')) {
    return diet.replace('Others', t('rsvp_form.diet_others'));
  }
  return diet;
};

export default function ReviewStep({
  formData,
  allGuests = [],
  onBack,
  onSubmit,
  submitting,
  success,
  titleKey = 'rsvp_form.review_title',
}) {
  const { t } = useLanguage();
  const yesLabel = t('rsvp_form.yes_label');
  const noLabel = t('rsvp_form.no_label');

  return (
    <div className="space-y-6 max-w-md font-normal">
      <h2 className="text-4xl text-content-h1">{t(titleKey)}</h2>

      <div className="space-y-4">
        {Object.keys(formData.individualResponses || {}).map((guestId) => {
          const resp = formData.individualResponses[guestId] || {};
          const guest = Array.isArray(allGuests)
            ? allGuests.find((g) => String(g.id) === String(guestId))
            : null;
          return (
            <div
              key={guestId}
              className="border-b border-wedding-divider pb-4 last:border-b-0"
            >
              <div className="text-3xl text-content-h2">
                {getGuestName(guestId, allGuests, t)}
              </div>
              <div className="mt-3 grid gap-2">
                {guest?.is_morning !== false && (
                  <div className="text-xl text-content-c2">
                    <strong>{t('rsvp_form.review_matrimony')}:</strong>{' '}
                    {formatResponse(resp.isAttendingMorning, yesLabel, noLabel)}
                  </div>
                )}
                {guest?.is_tea_ceremony !== false && (
                  <div className="text-xl text-content-c2">
                    <strong>
                      {t('rsvp_form.review_tea')}
                      {guest?.is_spectate_tea_ceremony === true
                        ? ` (${t('rsvp_form.tea_spectate_label')})`
                        : ''}
                      :
                    </strong>{' '}
                    {formatResponse(
                      resp.isAttendingTeaCeremony,
                      yesLabel,
                      noLabel,
                    )}
                  </div>
                )}
                {guest?.is_banquet !== false && (
                  <div className="text-xl text-content-c2">
                    <strong>{t('rsvp_form.review_dinner')}:</strong>{' '}
                    {formatResponse(resp.isAttendingBanquet, yesLabel, noLabel)}
                  </div>
                )}
                {guest?.is_banquet !== false &&
                  resp.isAttendingBanquet === true && (
                    <div className="text-xl text-content-c2">
                      <strong>{t('rsvp_form.review_meal')}:</strong>{' '}
                      {getBanquetChoiceLabel(resp.banquetChoice, t)}
                    </div>
                  )}
                {(resp.isAttendingMorning === true ||
                  resp.isAttendingBanquet === true) && (
                  <div className="text-xl text-content-c2">
                    <strong>{t('rsvp_form.review_dietary')}:</strong>{' '}
                    {getDietaryLabel(resp.dietaryRestrictions, t)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
